export const validateTelNumber = (number) => {
  if (!number || typeof number !== "string") return false;
  return /^[0-9+\-() ]+$/.test(number.trim());
};